import React, { useEffect, useState } from "react";
import isEmpty from "lodash/isEmpty";
import { Button, FormControl, InputGroup } from "react-bootstrap";

export const WowmaCategories = ({ categories: initialCategories, selected: initialSelected, name }) => {
    const categoryHash = {};
    const categoryRepo = initialCategories.split(',').map((s) => {
        const [parent, id, name] = s.split(':');
        return categoryHash[id] = { parent, id, name };
    });
    const initialSelection = () => {
        if (!initialSelected) {
            const defaultSelection = categoryRepo.filter(r => !r.parent).sort((a, b) => a.id - b.id)[0];
            console.log({ defaultSelection })
            return defaultSelection.id;
        }
        return initialSelected;
    };
    return <WowmaCategoriesImpl categoryHash={categoryHash} categoryRepo={categoryRepo}
        selected={initialSelection()} name={name} />
};

const CategorySearchBox = ({ keyword, onKeywordChange }) => {
    return <div>
        <InputGroup className="mb-3">
            <FormControl
                placeholder="カテゴリを検索"
                aria-label="カテゴリを検索"
                aria-describedby="basic-addon2"
                value={keyword} onChange={e => onKeywordChange(e.target.value)}
            />
            <Button variant="outline-secondary" onClick={() => onKeywordChange('')}><i className="fa fa-times" /></Button>
        </InputGroup>
    </div>
}

const CategoryCandidates = ({ keyword, onCategorySelect, setKeyword }) => {
    const [candidates, setCandidates] = useState([]);
    useEffect(() => {
        fetch(`/api/service-categories?keyword=${keyword}`)
            .then(e => e.json())
            .then(setCandidates);
    }, [keyword]);
    const genOnClick = category_id => e => {
        e.preventDefault();
        setKeyword('');
        onCategorySelect(category_id);
        return false;
    }
    return <ul>
        {
            candidates.map(arr =>
                <li key={`cat-candidate-${arr[arr.length - 1].category_id}`}>
                    <a href='#'
                        onClick={genOnClick(arr[arr.length - 1].category_id)}>{arr.map(({ name }) => name).join(' > ')}</a></li>)
        }
    </ul>
}

const WowmaCategoriesImpl = ({ categoryHash, categoryRepo, selected: initialSelected, name }) => {
    const [selected, setSelected] = useState(initialSelected);
    const [keyword, setKeyword] = useState('');

    const siblings = (category) =>
        categoryRepo.filter(r => category.parent === r.parent)
            .sort((a, b) => a.id - b.id);

    const getCategories = (category_id) => {
        const tree = [];
        let category = categoryHash[category_id];
        while (category !== undefined) {
            tree.unshift(category);
            category = categoryHash[category.parent];
        }
        const categories = tree.map((category) => siblings(category));
        const children = siblings({ parent: category_id });
        if (children.length) {
            categories.push(children);
        }
        return { tree, categories };
    };

    const { tree, categories } = getCategories(selected);
    const selectedCategory = categoryHash[selected];

    return <div>
        <input type='hidden' name={name} value={selected} />
        <label>{`Qoo10カテゴリー「${selectedCategory.name}(${selectedCategory.id})」にマッピングする`}</label>
        <CategorySearchBox keyword={keyword} onKeywordChange={setKeyword} />
        {
            !isEmpty(keyword) &&
            <CategoryCandidates keyword={keyword} onCategorySelect={setSelected} setKeyword={setKeyword} />
        }
        {
            isEmpty(keyword) &&
            <ul className='categories-container mt-4'>
                {
                    categories.map((arr, i) => <li key={`category-group-${i}`} className='categories'>
                        <ul>
                            {
                                arr.map((category) => {
                                    const classes = ['category'];
                                    if (tree.indexOf(category) > -1) {
                                        classes.push('active');
                                    }
                                    if (category.id === selected) {
                                        classes.push('selected');
                                    }
                                    return <li key={`category-${category.id}`} className={classes.join(' ')}
                                        onClick={(e) => setSelected(category.id)}>
                                        {category.name}</li>;
                                })
                            }
                        </ul>
                    </li>)
                }
            </ul>
        }
    </div>;
}
